// Google Identity Services (the "Continue with Google" button). The script is
// loaded only when the sign-in form shows the button, i.e. only when a Google
// client ID is configured (static_store.google_oauth_client_id). Loaded once;
// later calls share the same promise. Resolves to google.accounts.id.
const GIS_SRC = 'https://accounts.google.com/gsi/client';

let loading = null;

export function loadGoogleIdentity() {
  if (window.google?.accounts?.id) return Promise.resolve(window.google.accounts.id);
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = GIS_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => (window.google?.accounts?.id
      ? resolve(window.google.accounts.id)
      : reject(new Error('Google Identity Services did not load')));
    script.onerror = () => reject(new Error('Google Identity Services did not load'));
    document.head.appendChild(script);
  }).catch((e) => {
    // A blocked script (an ad blocker, no network) can be tried again later.
    loading = null;
    throw e;
  });
  return loading;
}
